var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M0 0H72V72H0z",
    transform: "translate(-4 -4) translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#12CC94",
    d: "M63.563 24.065L49.78 47.935 36 24.065h27.563zm-41.344 0L36 47.935H8.437l13.782-23.87z",
    transform: "translate(-4 -4) translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4E5D9",
    d: "M36 47.935L22.219 24.065 49.781 24.065zM56.672 36L49.781 24.065 63.563 24.065z",
    transform: "translate(-4 -4) translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.384 33.016l3.445 5.968h-6.89l3.445-5.968zm22.397-8.95L42.891 36 36 24.065h13.781z",
    transform: "translate(-4 -4) translate(4 4)"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.4b22235074513dc14e9ceb2df1ab8e47.svg";